import { render, staticRenderFns } from "./QuizSlide.vue?vue&type=template&id=4260be74&scoped=true"
import script from "./QuizSlide.vue?vue&type=script&lang=js"
export * from "./QuizSlide.vue?vue&type=script&lang=js"
import style0 from "./QuizSlide.vue?vue&type=style&index=0&id=4260be74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260be74",
  null
  
)

export default component.exports